import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, FloorLabel } from "../motion/Reveal";
import { t } from "../../lib/i18n";

/** Three markets as three quiet columns – number, name, one sentence, and the segments as a single line. */
export const MarketsFloor = ({ markets = [] }) => (
  <section data-testid="floor-markeder" className="bg-surface">
    <div className="wrap floor">
      <Reveal className="grid-12 gap-y-6 items-end">
        <div className="col-span-12 lg:col-span-6">
          <FloorLabel>{t("Markeder")}</FloorLabel>
          <h2 className="mt-4 t-h2">{t("Der industrien skjer")}</h2>
        </div>
        <div className="col-span-12 lg:col-span-5 lg:col-start-8">
          <p className="t-body text-muted max-w-[46ch]">{t("Fra prosessanlegg og havbruk til kraftproduksjon og nye industriprosjekter. EQVA-selskapene kombinerer lokal tilstedeværelse med spesialistkompetanse på tvers av konsernet.")}</p>
          <Link to="/markeder" data-testid="markets-link" className="link-arrow mt-5 t-small">{t("Utforsk markedene")} <ArrowRight size={16} /></Link>
        </div>
      </Reveal>

      <div className="mt-14 md:mt-20 grid md:grid-cols-3 border-t border-line">
        {markets.map((m, i) => (
          <Reveal
            key={m.slug}
            delay={i * 80}
            data-testid={`market-column-${i}`}
            className="pt-8 pb-10 md:pb-4 md:pr-10 md:[&:not(:last-child)]:border-r md:border-line md:[&:not(:first-child)]:pl-10 flex flex-col"
          >
            <p className="tabular t-small text-muted">{String(i + 1).padStart(2, "0")}</p>
            <h3 className="mt-3 t-h3">
              <Link to={`/markeder#${m.slug}`} data-testid={`market-link-${m.slug}`} className="link-underline">{m.name}</Link>
            </h3>
            {m.lead && <p className="mt-4 t-body text-muted max-w-[36ch]">{m.lead}</p>}
            <p className="mt-auto pt-8 t-small text-muted">{(m.items || []).join(" · ")}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
